import { ICoupon } from 'interfaces/coupon';
import { invalidateGetResponse } from 'utils/common';

const BASE_COUPON_URL = '/coupon';

const fetchCoupons = () =>
  invalidateGetResponse<ICoupon[]>({
    url: BASE_COUPON_URL,
    options: { params: { up: 'food' } },
  });

export default {
  fetchCoupons,
};
